import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import Login from "../pages/Login";
import Home from "../pages/Home";
import Register from "../pages/Register";
import Header from "../components/header";
import Footer from "../components/footer";
import Entrepreneur from "../pages/ Entrepreneur";
import JobReferal from "../pages/JobReferal";
import JobReferralPostDetails from "../pages/JobReferralPostDetails";
import BloodDonar from "../pages/BloodDonar";
import Events from "../pages/Events";
import Profile from "../pages/Profile";
import AssociationMembers from "../pages/AssociationMembers";
import Notifications from "../pages/Notifications";
import Users from "../pages/admin/Users";
import AddGalleryImages from "../pages/admin/AddGalleryImages";
import Gallery from "../pages/Gallery";
import FeedbackForm from "../pages/FeedbackForm";
import FeedbackViewer from "../pages/admin/FeedbackViewer";

function getRouterBasename() {
  const publicUrl = process.env.PUBLIC_URL;

  if (!publicUrl) {
    return undefined;
  }

  try {
    const url = new URL(publicUrl, window.location.origin);
    return url.pathname.replace(/\/$/, "") || "/";
  } catch {
    return publicUrl.replace(/\/$/, "") || "/";
  }
}

function AdminRoute({ children }) {
  const user = useSelector((state) => state.user.user);
  const role = (user?.role || user?.Role || "").toString().toLowerCase();

  if (role !== "admin") {
    return <Navigate to="/" replace />;
  }

  return children;
}

function UnAuthNavigator() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/events" element={<Events />} />
      <Route path="/gallery" element={<Navigate to="/login" replace />} />
      <Route path="/gallery/:albumId" element={<Navigate to="/login" replace />} />
      <Route path="/association-members" element={<AssociationMembers />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/feedback" element={<Navigate to="/login" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function AuthNavigator() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/home" element={<Home />} />
      <Route path="/events" element={<Events />} />
      <Route path="/gallery" element={<Gallery />} />
      <Route path="/gallery/:albumId" element={<Gallery />} />
      <Route path="/entrepreneurs" element={<Entrepreneur />} />
      <Route path="/blood-donation" element={<BloodDonar />} />
      <Route path="/job-referral" element={<JobReferal />} />
      <Route path="/feedback" element={<FeedbackForm />} />
      <Route path="/association-members" element={<AssociationMembers />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/notifications" element={<Notifications />} />
      <Route
        path="/users"
        element={
          <AdminRoute>
            <Users />
          </AdminRoute>
        }
      />
      <Route
        path="/admin/gallery"
        element={
          <AdminRoute>
            <AddGalleryImages />
          </AdminRoute>
        }
      />
      <Route
        path="/admin/feedback"
        element={
          <AdminRoute>
            <FeedbackViewer />
          </AdminRoute>
        }
      />
      <Route
        path="/job-referral/:postId"
        element={<JobReferralPostDetails />}
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function Navigator() {
  const { isAuthenticated } = useSelector((state) => state.user);

  return (
    <BrowserRouter basename={getRouterBasename()}>
      <Header />
      {isAuthenticated ? <AuthNavigator /> : <UnAuthNavigator />}
      <Footer />
    </BrowserRouter>
  );
}

export default Navigator;
